/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 14/9/2020
 */

import FormElementType from "@/core/modules/coach/Resources/Forms/model/FormElements/FormElementType";

export const FormSpecialFieldEnum = Object.freeze({
	FULL_NAME: FormElementType.FULL_NAME,
	EMAIL: FormElementType.EMAIL_ADDRESS,
	PHONE: FormElementType.PHONE_NUMBER,
	ADDRESS: FormElementType.ADDRESS,
	DATE_OF_BIRTH: FormElementType.DATE_OF_BIRTH,
	EMERGENCY_CONTACTS: FormElementType.EMERGENCY_CONTACTS,
})

